<template>
	<div
		:id="this.uniqueId"
		class="w-full m-h-i flex-1"
	>
		<div class="w-full m-h-i">
			<div
				class="table-responsive m-h-i"
				v-if="headers.length > 0"
				:style="{
					...style_table,
				}"
				@scroll.capture="ScrollEvent"
				ref="table"
			>
				<table class="table table-custom font-14">
					<colgroup v-if="withHeaderActions">
						<col style="width: 2rem" />
						<col
							v-for="(_, index) in headers"
							:key="index"
							style="width: 1fr"
						/>
						<col style="width: 1%" />
					</colgroup>
					<thead
						:class="{
							'fixed-header': fixedHeader,
						}"
						:style="{
							...style_header,
						}"
					>
						<tr
							:class="{
								checkboxed: checkbox,
							}"
						>
							<th
								v-if="checkbox"
								class="checkbox-container"
							>
								<div class="form-check">
									<input
										type="checkbox"
										id="checkbox-all"
										v-model="check_all"
										@change="EmitCheckboxes"
									/>
									<label
										for="checkbox-all"
										class="form-check-label"
									></label>
								</div>
							</th>
							<th
								v-for="(header, index) in headers"
								:key="index"
								class="datatable-header"
								:class="{
									'text-center': header.align == 'center',
									'text-left': header.align == 'left',
									'text-right': header.align == 'right',
									sortable: header.value && header.sortable,
									active: sortedBy.column == header.value,
									'pb-1': !fixedHeader,
								}"
								@click="SortData(header)"
							>
								<div
									class="th-content"
									:class="{
										'pl-5':
											header.type &&
											header.type === 'status',
									}"
								>
									{{ header.text }}
									<div class="sort-icon">
										<i
											:class="`far ${sortedBy.icon}`"
											v-if="
												sortedBy.column == header.value
											"
										/>
									</div>
								</div>
							</th>
							<slot name="header-actions"></slot>
						</tr>
					</thead>
					<transition
						name="fast-fade"
						mode="out-in"
					>
						<tbody v-if="filtered_items.length > 0">
							<tr
								v-for="(item, index) in filtered_items"
								:class="[
									{
										'tr-btn': trButton,
										checkboxed: checkbox,
									},
									row_color
										? item.row_status_color
											? item.row_status_color
											: item.row_color
										: '',
									GetItemStatusColor(item),
									GetItemTypeColor(item),
								]"
								:key="index * Math.random()"
								@click="ByClickOnTR(item, $event)"
							>
								<td
									v-if="checkbox"
									class="checkbox-container"
									@click.stop
									@mousedown.stop
								>
									<div class="form-check">
										<input
											type="checkbox"
											:id="`checkbox-${index}`"
											:value="item[checkbox_value]"
											v-model="selected_checkboxes"
											@change="EmitCheckboxes"
										/>
										<label
											:for="`checkbox-${index}`"
											class="form-check-label"
										></label>
									</div>
								</td>
								<slot
									name="body"
									:item="item"
									:index="index"
								></slot>
							</tr>
						</tbody>
						<tbody
							v-else-if="
								filtered_items.length < 1 && items.length > 0
							"
							key="empty"
						>
							<tr>
								<td :colspan="headers.length">
									<slot name="no-match">
										<div class="custom-alert-warning">
											<b
												>SUA PESQUISA POR "{{ search }}"
												RETORNOU SEM RESULTADOS.</b
											>
										</div>
									</slot>
								</td>
							</tr>
						</tbody>
						<tbody
							v-else
							key="no-data"
						>
							<tr>
								<td
									:colspan="
										checkbox
											? headers.length + 1
											: headers.length
									"
								>
									<slot name="no-data">
										<div class="custom-alert-info">
											<b>NÁO HÁ REGISTROS PARA EXIBIR.</b>
										</div>
									</slot>
								</td>
							</tr>
						</tbody>
					</transition>
					<tfoot v-if="items.length > 0">
						<tr>
							<slot
								name="footer"
								:items="items"
							></slot>
						</tr>
					</tfoot>
				</table>
			</div>
		</div>
		<div
			class="col-12 text-center text-md-right mt-3 align-self-center counter"
			v-if="
				(filtered_items.length ? filtered_items.length : items.length) >
					0 && showTotal
			"
			:style="{
				...style_footer,
			}"
		>
			<span>
				{{
					paginate
						? `DE ${paginateSetup.init_item} ATÉ ${
								paginateSetup.end_item
						  } DE ${
								filtered_items.length
									? filtered_items.length
									: items.length
						  } ITENS`
						: `EXIBIDOS: ${
								filtered_items.length
									? filtered_items.length
									: items.length
						  } ${total ? 'DE ' + numberWithDots(total) : ''} ITENS`
				}}
			</span>
		</div>
		<div
			class="col-12 col-md text-center text-md-right mt-3 align-self-center"
			v-if="paginate"
		>
			<div class="btn-group btn-group-sm">
				<button
					type="button"
					class="btn btn-primary"
					:disabled="paginateSetup.page === 1"
					@click="WalkPaginate('prev')"
				>
					ANTERIOR
				</button>
				<button
					type="button"
					class="btn btn-primary"
					disabled
				>
					{{ paginateSetup.page }}
				</button>
				<button
					type="button"
					class="btn btn-primary"
					:disabled="
						paginateSetup.page === paginateSetup.total_pages ||
						filtered_items.length < 1
					"
					@click="WalkPaginate('next')"
				>
					PRÓXIMO
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	import Helpers from '../../../helpers'

	const _ = require('lodash')

	const helpers = new Helpers()

	import moment from 'moment'
	import { useGetUniqueId } from '@/composables'

	export default {
		name: 'DataTables',
		props: {
			type: {
				type: String,
				default: '',
			},
			value: {
				type: Array,
				required: false,
				default: () => [],
			},
			headers: {
				type: Array,
				required: true,
				default: () => [],
			},
			search: {
				type: String,
				required: false,
				default: '',
			},
			paginate: {
				type: Boolean,
				required: false,
				default: false,
			},
			itemsPerPage: {
				type: Number,
				required: false,
				default: 10,
			},
			trButton: {
				type: Boolean,
				required: false,
				default: false,
			},
			checkbox: {
				type: Boolean,
				default: false,
			},
			row_color: {
				type: Boolean,
				default: false,
			},
			checkbox_value: {
				type: String,
				default: 'id',
			},
			height: {
				type: String,
				required: false,
				default: null,
			},
			max_height: {
				type: String,
				required: false,
				default: null,
			},
			min_height: {
				type: String,
				required: false,
				default: null,
			},
			scrollUpdate: {
				type: Boolean,
				default: false,
			},
			offset: {
				type: [String, Number],
				default: '',
			},
			prop_sortedBy: {
				type: Object,
				default: () => {},
			},
			fetchSort: {
				type: Boolean,
				default: false,
			},
			returnFetchSort: {
				type: Boolean,
				default: true,
			},
			total: {
				type: Number,
				default: null,
			},
			showTotal: {
				type: Boolean,
				default: true,
			},
			fixedHeader: {
				type: Boolean,
				default: false,
			},
			header_style: {
				type: Object,
				required: false,
				default: () => {},
			},
			footer_style: {
				type: Object,
				required: false,
				default: () => {},
			},
			withHeaderActions: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				uniqueId: '',
				currentPage: 1,
				items: [],
				items_limiteds: [],
				sortedBy: {
					column: '',
					direction: '',
					icon: '',
				},
				paginateSetup: {
					page: null,
					per_page: null,
					pre_page: null,
					next_page: null,
					total: null,
					total_pages: null,
					data: [],
				},
				selected_checkboxes: [],
				check_all: false,
			}
		},
		computed: {
			style_table() {
				const vm = this

				let obj = {}

				if (vm.height) obj.height = vm.height

				if (vm.max_height) obj['max-height'] = vm.max_height

				if (vm.min_height) obj['min-height'] = vm.min_height

				return obj
			},
			style_header() {
				const vm = this

				return vm.header_style ?? {}
			},
			style_footer() {
				const vm = this

				return vm.footer_style ?? {}
			},
			filtered_items() {
				//BUSCA
				let items = this.items.filter(item => {
					let search = helpers
						.SanitizedDocument(helpers.RemoveAcento(this.search))
						.toString()
						.toLowerCase()
						.trim()
					let match = false

					this.headers.map(header => {
						if (header.value && window._.get(item, header.value)) {
							let i = helpers
								.SanitizedDocument(
									helpers.RemoveAcento(
										window._.get(item, header.value)
									)
								)
								.toString()
								.toLowerCase()
								.trim()

							if (i.indexOf(search) > -1) {
								match = true
							}
						}
					})

					return this.search && this.headers.length > 0 ? match : true
				})

				//ORDENAÇÃO
				if (!this.fetchSort) {
					this.headers.map(header => {
						if (header.value == this.sortedBy.column) {
							items.sort(
								this.OrderItems(
									header.value,
									this.sortedBy.direction
								)
							)
						}
					})
				}

				//PAGINATION
				if (this.paginate) {
					let itemsPerPage = this.itemsPerPage ? this.itemsPerPage : 5

					let numberOfPages = Math.ceil(items.length / itemsPerPage)

					let paginate = this.Paginate(
						items,
						this.currentPage,
						itemsPerPage
					)

					items = paginate.data
					this.paginateSetup = paginate
				}

				return items
			},
		},
		watch: {
			prop_sortedBy: {
				immediate: true,
				handler(val) {
					if (val) {
						this.sortedBy = { ...val }
					}
				},
			},
			value: {
				immediate: true,
				handler(val) {
					this.items = val
					this.selected_checkboxes = []
					this.check_all = false
				},
				deep: true,
			},
			check_all: {
				handler(val) {
					if (val) {
						this.selected_checkboxes = this.items.map(
							item => item[this.checkbox_value]
						)
					} else {
						if (
							this.selected_checkboxes.length ===
							this.items.length
						) {
							this.selected_checkboxes = []
						}
					}

					this.EmitCheckboxes()
				},
			},
			selected_checkboxes: {
				handler(val) {
					if (this.items.length > 0) {
						const allChecked = this.items.every(item =>
							val.includes(item[this.checkbox_value])
						)
						if (allChecked) {
							if (!this.check_all) this.check_all = true
						} else {
							if (this.check_all) this.check_all = false
						}
					} else {
						if (this.check_all) this.check_all = false
					}
				},
				deep: true,
			},
			filtered_items: {
				handler(val) {
					this.$emit('filtered-items-count', val.length)
				},
				immediate: true,
			},
		},
		methods: {
			EmitCheckboxes() {
				this.$emit('checkeds', this.selected_checkboxes)
			},
			ByClickOnTR(item, event) {
				if (event && event.target && event.target.type === 'checkbox')
					return
				if (this.trButton) {
					this.$emit('by-click-on-tr', item)
				}
			},
			OrderItems(key, order = 'ASC') {
				return function InnerSort(a, b) {
					if (
						typeof window._.get(a, key) === 'boolean' ||
						typeof window._.get(b, key) === 'boolean'
					) {
						if (window._.get(a, key) && !window._.get(b, key)) {
							return order === 'DESC' ? 1 : -1
						} else if (
							!window._.get(a, key) &&
							window._.get(b, key)
						) {
							return order === 'DESC' ? -1 : 1
						}

						return 0
					}

					if (!window._.get(a, key) || !window._.get(b, key)) {
						return 0
					}

					const varA =
						typeof window._.get(a, key) === 'string'
							? window._.get(a, key).toUpperCase()
							: window._.get(a, key)
					const varB =
						typeof window._.get(b, key) === 'string'
							? window._.get(b, key).toUpperCase()
							: window._.get(b, key)

					let comparison = 0

					const dateA = moment(varA, 'DD/MM/YYYY')
					const dateB = moment(varB, 'DD/MM/YYYY')

					if (dateA._isValid && dateB._isValid) {
						comparison = dateA > dateB ? 1 : -1
					} else {
						if (varA > varB) {
							comparison = 1
						} else if (varA < varB) {
							comparison = -1
						}
					}

					return order === 'DESC' ? comparison * -1 : comparison
				}
			},
			Paginate(items, page = 1, per_page = 5) {
				page = page || 1
				per_page = per_page || 5
				let offset = (page - 1) * per_page
				let paginatedItems = items.slice(offset).slice(0, per_page)
				let total_pages = Math.ceil(items.length / per_page)

				return {
					page: page,
					per_page: per_page,
					init_item: offset + 1,
					end_item: offset + paginatedItems.length,
					pre_page: page - 1 ? page - 1 : null,
					next_page: total_pages > page ? page + 1 : null,
					total: items.length,
					total_pages: total_pages,
					data: paginatedItems,
				}
			},
			WalkPaginate(mode) {
				switch (mode) {
					case 'prev':
						this.currentPage =
							this.currentPage <= 1 ? 1 : this.currentPage - 1
						break
					case 'next':
						this.currentPage =
							this.currentPage < this.paginateSetup.total_pages
								? this.currentPage + 1
								: this.currentPage -
								  this.paginateSetup.total_pages
						break
				}
			},
			SortData(header) {
				if (header.value && header.sortable) {
					if (this.sortedBy.column != header.value) {
						this.sortedBy.column = header.value
						this.sortedBy.direction = ''
						this.sortedBy.icon = ''
					}

					let items = [...this.items]

					switch (this.sortedBy.direction) {
						case 'ASC':
							this.sortedBy.direction = 'DESC'
							this.sortedBy.icon = 'fa-chevron-down'

							items.sort(
								this.OrderItems(
									header.value,
									this.sortedBy.direction
								)
							)
							break
						case 'DESC':
							this.sortedBy.column = ''
							this.sortedBy.direction = ''
							this.sortedBy.icon = ''

							items.sort(
								this.OrderItems(
									this.headers[0].value,
									this.sortedBy.direction
								)
							)
							break
						default:
							this.sortedBy.direction = 'ASC'
							this.sortedBy.icon = 'fa-chevron-up'

							items.sort(
								this.OrderItems(
									header.value,
									this.sortedBy.direction
								)
							)
							break
					}

					if (this.fetchSort) {
						this.$emit('fetch', { ...this.sortedBy })

						if (this.returnFetchSort) {
							return
						}
					}

					this.items = [...items]
				}
			},
			ScrollEvent(event) {
				if (this.scrollUpdate) {
					const vm = this
					const table = this.$refs.table

					let bottomTable =
						table.offsetHeight + Math.ceil(table.scrollTop) >=
						table.scrollHeight
					let newOffset = vm.offset + 200

					if (bottomTable) {
						vm.$emit('load-table', {
							offset: newOffset,
						})
					}
				}
			},
			numberWithDots(x) {
				return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
			},
			GetItemStatusColor(item) {
				if (!item.status) return ''

				return `status ${item.status.toString().toLowerCase()}`
			},
			GetItemTypeColor(item) {
				if (!item.type) return ''

				return item.type.toString().toLowerCase()
			},
		},
		beforeMount() {
			this.uniqueId = useGetUniqueId('datatable')
		},
	}
</script>

<style lang="scss" scoped>
	table.table-custom {
		border-spacing: 0 0.2em;

		tr {
			.checkbox-container {
				padding: 0;
				padding-right: 0.75rem;
				min-width: unset;
				max-width: unset;
				border: none;
				background-color: transparent;
			}

			.action-column {
				width: fit-content;
				display: flex;
				padding-right: 0;
			}
		}

		.form-check {
			justify-content: center;
		}
	}

	:deep(.table-custom tbody tr td.action-column, th.action-column) {
		padding: 0;
		padding-left: 0.5rem;
	}

	:deep(.table-custom thead tr.checkboxed th:nth-child(2)) {
		padding-left: 1rem;
	}

	:deep(.table-custom tbody tr.checkboxed td:nth-child(2)) {
		padding-left: 1rem;
		border-top-left-radius: 1rem;
		border-bottom-left-radius: 1rem;
	}

	:deep(.table-custom tbody tr td.action-column) {
		border: 0;
		background: transparent;
	}

	:deep(.table-custom tbody tr td:not(.action-column):has(+ .action-column)),
	:deep(.table-custom tbody tr td:last-child:not(.action-column)) {
		border-top-right-radius: 1rem;
		border-bottom-right-radius: 1rem;
	}

	table.table-custom .th-content {
		display: flex;
		flex-direction: row;
	}

	table.table-custom .th-content .sort-icon {
		margin: 0 5px;
	}

	table.table-custom .header-sticky {
		position: sticky;
	}

	.form-check input:checked ~ label:after {
		background-color: var(--newPrimaryBackgroundColor);
	}

	.table-custom thead th {
		border: 0;
		padding: 0;
		background-color: var(--elementsBackgroundColor);
	}

	.m-h-i {
		max-height: inherit;
	}
</style>
